import React, { useState } from 'react'

import Tabs from '@components/Tabs/Tabs'

import DEIPageBarChart from '../DEIPageBarChart/DEIPageBarChart'

import {
  DEIPageDemographicsSectionSECTION,
} from './DEIPageDemographicsSection.styles'

const DEIPageDemographicsSection = ({
  fullTeam,
}) => {
  const {
    age,
    physicalDisability,
    neurodivergent,
    parentsGuardians,
    lgbq,
    transgender,
    education,
    veterans,
  } = fullTeam

  const demographics = [
    age,
    physicalDisability,
    neurodivergent,
    parentsGuardians,
    lgbq,
    transgender,
    education,
    veterans,
  ]

  const [activeTab, setActiveTab] = useState(0)

  return (
    <DEIPageDemographicsSectionSECTION>
      <div className="container">
        <Tabs
          activeOption={activeTab}
          onClickOption={value => setActiveTab(value)}
          options={demographics.map(({ title }, i) => ({
            title,
            value: i,
          }))}
        />
        <DEIPageBarChart data={demographics[activeTab]} />
      </div>
    </DEIPageDemographicsSectionSECTION>
  )
}

export default DEIPageDemographicsSection
